export default "__VITE_ASSET__CJxdp6vR__"